<template>
  <div>
      <h3>{{ $t("viewSettings.importExternalData.import_one_cv_customers") }}</h3>
      <v-form ref="formCustomers">
        <v-file-input
            :key="componentKey"
            :disabled="savingInProgress"
            accept=".xls"
            :label="$t('viewSettings.importExternalData.select_file_for_uploading')"
            @change="uploadImportFileChange($event, 'importCustomersFile')"
            :rules="[(v) => (!!v && !!v.name) || $t('form.validationErrors.field_is_required')]"
        ></v-file-input>
      </v-form>
      <v-btn
          :loading="savingInProgress"
          :disabled="savingInProgress || !importCustomersFile.filename || importCustomersFile.external_name !==external_name"
          class="mr-2 mt-4"
          color="primary"
          @click.stop="uploadCustomersFile"
          @keyup.enter.stop="uploadCustomersFile"
      >
        {{ $t('viewSettings.importExternalData.import_one_cv_customers_btn') }}
      </v-btn>
      <h3 class="mt-5">{{ $t("viewSettings.importExternalData.import_one_cv_orders") }}</h3>

      <v-form ref="formOrders">
        <v-file-input
            :disabled="savingInProgress"
            :key="componentKey2"
            accept=".xls"
            :label="$t('viewSettings.importExternalData.select_file_for_uploading')"
            @change="uploadImportFileChange($event, 'importOrdersFile')"
            :rules="[(v) => (!!v && !!v.name) || $t('form.validationErrors.field_is_required')]"
        ></v-file-input>
      </v-form>
      <v-btn
          :loading="savingInProgress"
          :disabled="savingInProgress || !importOrdersFile.filename || importOrdersFile.external_name !==external_name"
          class="mr-2 mt-4"
          color="primary"
          @click.stop="uploadOrdersFile"
          @keyup.enter.stop="uploadOrdersFile"
      >
        {{ $t('viewSettings.importExternalData.import_one_cv_orders_btn') }}
      </v-btn>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  name: "ImportCustomersAndOrdersOneCV",
  data: () => ({
    external_name: "ONE_C_V",
    componentKey: 0, //для того чтобы можно было выбирать один и тот же файл несколько раз иначе событие Change не сработает
    componentKey2: 0, //для того чтобы можно было выбирать один и тот же файл несколько раз иначе событие Change не сработает
  }),
  created() {

  },
  computed: {
    ...mapFields("auth", ["authenticatedUser"]),
    ...mapFields('data_import', [
      'importCustomersFile',
      'importOrdersFile',
      'savingInProgress',
    ]),
  },
  watch: {},
  methods: {
    uploadImportFileChange(file, type){
      this[type].external_name = this.external_name;
      if(file){
        if(file.name){
          this[type].filename = file.name;
          this[type].extension = file.name.split('.').pop();
        }
      } else {
        this[type].filename = null;
        this[type].extension = null;
      }
      this[type].file = file;
    },
    uploadCustomersFile(){
      if(this.importCustomersFile.extension.split('.').pop() != 'xls'){
        this.$error(this.$t('viewImportToStorage.wrong_file_type', ['xls']));
        this.componentKey++;
        this.$refs.formCustomers.reset();
        this.importCustomersFile.filename = null;
      } else {
        this.$store.dispatch('data_import/uploadImportCustomersFile').finally(()=>{
          this.$refs.formCustomers.reset();
          this.componentKey++;
          this.importCustomersFile.filename = null;
        })
      }

    },
    uploadOrdersFile(){
      if(this.importOrdersFile.extension.split('.').pop() != 'xls'){
        this.$error(this.$t('viewImportToStorage.wrong_file_type', ['xls']));
        this.componentKey2++;
        this.$refs.formOrders.reset();
      } else {
        this.$store.dispatch('data_import/uploadImportOrdersFile').finally(()=>{
          this.$refs.formOrders.reset();
          this.componentKey2++;
        })
      }

    },
  },
};
</script>

<style scoped></style>
